import { sendCustomEvent as m } from "@perxis-auto/shared";
import { EVENTS_CHANNEL as n } from "../../config/events.js";
const s = (o, t, e) => {
  m(n, o, t, e);
};
export {
  s as sendEvent
};
